// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-close{position:absolute;top:10px;right:10px;background-color:#fff;border-radius:50%;padding:5px;display:flex}", ""]);
// Exports
module.exports = exports;
